type SpeechBubbleSvgProps = {
    width: number;
    height: number;
    arrowPosition: 'bottom-left' | 'bottom-center' | 'bottom-right';
    paddingSize: 'small' | 'large';
    fillColor: string | null;
    strokeColor: string | null;
};

const arrowConfig = {
    small: { sideHeight: 10, centerHeight: 16, centerWidth: 20 },
    large: { sideHeight: 14, centerHeight: 24, centerWidth: 28 },
};

export const SpeechBubbleSvg = ({ width, height, arrowPosition, paddingSize, fillColor, strokeColor }: SpeechBubbleSvgProps) => {
    const strokeWidth = strokeColor ? 2 : 0;
    const offset = strokeWidth / 2;
    const w = width - strokeWidth;
    const h = height - strokeWidth;
    const r = h / 2;

    const { sideHeight, centerHeight, centerWidth } = arrowConfig[paddingSize];
    const arrowHeight = arrowPosition === 'bottom-center' ? centerHeight : sideHeight;

    const topArc = `M ${offset + r} ${offset} L ${offset + w - r} ${offset}`;
    const bottomLeftArc = `A ${r} ${r} 0 0 1 ${offset} ${offset + r} A ${r} ${r} 0 0 1 ${offset + r} ${offset}`;

    const paths: Record<string, string> = {
        'bottom-left': (() => {
            const startY = h * 0.82;
            const returnX = r * 0.65;
            return `
                ${topArc}
                A ${r} ${r} 0 0 1 ${offset + w} ${offset + r}
                A ${r} ${r} 0 0 1 ${offset + w - r} ${offset + h}
                L ${offset + returnX} ${offset + h}
                L ${offset} ${offset + h + sideHeight}
                L ${offset + r * 0.12} ${offset + startY}
                A ${r} ${r} 0 0 1 ${offset + r} ${offset}
                Z
            `;
        })(),
        'bottom-right': (() => {
            const startY = h * 0.82;
            const returnX = w - r * 0.65;
            return `
                ${topArc}
                A ${r} ${r} 0 0 1 ${offset + w - r * 0.12} ${offset + startY}
                L ${offset + w} ${offset + h + sideHeight}
                L ${offset + returnX} ${offset + h}
                L ${offset + r} ${offset + h}
                ${bottomLeftArc}
                Z
            `;
        })(),
        'bottom-center': (() => {
            const startX = (w - centerWidth) / 2;
            return `
                ${topArc}
                A ${r} ${r} 0 0 1 ${offset + w} ${offset + r}
                A ${r} ${r} 0 0 1 ${offset + w - r} ${offset + h}
                L ${offset + startX + centerWidth} ${offset + h}
                L ${offset + startX + centerWidth / 2} ${offset + h + centerHeight}
                L ${offset + startX} ${offset + h}
                L ${offset + r} ${offset + h}
                ${bottomLeftArc}
                Z
            `;
        })(),
    };

    return (
        <svg className="r-pointer-events-none r-absolute r-inset-0" width={width} height={height + arrowHeight} style={{ overflow: 'visible' }}>
            <path d={paths[arrowPosition]} fill={fillColor || 'transparent'} stroke={strokeColor || 'none'} strokeWidth={strokeWidth} />
        </svg>
    );
};
